import gql from 'graphql-tag';

export const FILE_FOLDER_LIST = gql`
  query file_folder_list($id: ID!, $show_deleted: Boolean) {
    folder(id: $id) {
      id
      name
      folders {
        id
        name
        last_modified
      }
      files(show_deleted: $show_deleted) {
        id
        name
        size
        last_modified
        deleted
        warnings
      }
      parents {
        id
        name
      }
    }
  }`

export const GET_PARENTS = gql`
  query get_parents($id: ID!) {
    folder(id: $id) {
      id
      name
      parents {
        id
        name
      }
    }
  }`

export const FILE_FOLDER_LIST_WITH_ARCHIVE = gql`
  query filefolderlistwitharchive($id: ID!, $show_deleted: Boolean) {
    folder(id: $id){
      id
      name
      folders {
        id
        name
        last_modified
      }
      files(show_deleted: $show_deleted) {
        id
        name
        size
        last_modified
        deleted
        archived
        warnings
        archive {
          restore_state
          expiration
          extra {
            restore_tier
            restore_requested
            deep_archive
          }
        }
        tracks {
          index
          enabled
          language
          track_type
        }
      }
      parents {
        id
        name
      }
    }
  }`

export const GET_PO = gql`
  query filefolderlistwitharchive($id: ID!, $show_deleted: Boolean) {
    folder(id: $id){
      id
      name
      folders {
        id
        name
      }
      files(show_deleted: $show_deleted) {
        id
        name
        size
        last_modified
        deleted
        archived
        archive {
          restore_state
          expiration
          extra {
            restore_tier
            restore_requested
            deep_archive
          }
        }
        tracks {
          index
          enabled
          language
          track_type
        }
      }
      parents {
        id
        name
      }
    }
  }`

export const FILE_ARCHIVE_STATE = gql`
  query file_archive_state($id: ID!) {
    file(id: $id) {
      id
      archived
      archive {
        restore_state
        expiration
        extra {
          restore_tier
          restore_requested
          deep_archive
        }
      }
    }
  }
`

export const CREATE_UPLOAD_TICKET = gql`mutation create_upload_ticket($folder_id: ID!, $message: String!) {
  createUploadTicket(input: {folder_id: $folder_id, message: $message}) {
    directory
    token
    url
    expiration
  }
}
`

export const RESTORE = gql`mutation restore_file($files: [ID]!, $tier: RestoreTier!, $days: Int = 14) {
  restore(input: {files: $files, tier: $tier, days: $days}) {
    action
    data
    message
    state
    id
  }
}
`
export const PREVIEW_PREPARE = gql`mutation preview_preparation($folder_id: ID!) {
  previewPrepare(input: {folder_id: $folder_id}) {
    action
    data
    message
    state
    id
  }
}
`
export const PREVIEW_GENERATE = gql`mutation preview_generation($folder_id: ID!, $force: Boolean) {
  previewGenerate(input: {folder_id: $folder_id, force: $force}) {
    action
    data
    message
    state
    id
  }
}
`

export const START_GENERATE_STILLS = gql`mutation generate_stills($file_id: ID!) {
  generate_stills(input: {file_id: $file_id}) {
    action
    data
    message
    state
    id
  }
}
`

export const GET_PROCESS = gql`query GetProcess($id: ID!) {
  process(id: $id) {
    action
    data
    id
    message
    state
    start_date
    end_date
  }
}
`

export const GET_UPFRONT_TOKEN = gql`mutation GetUpfrontToken($asset_id: String) {
  previewGenerateToken(input: { asset_id: $asset_id } ) {
    access_token
    drmtoday_token
    asset_id
    dash_url
  }
}
`

export const GET_FOLDER2 = gql`query GetFolder2($id: ID!) {
  folder(id: $id) {
    id
    name
    files {
      id
      tracks {
        track_type
        enabled
        index
        language
      }
    }
    tags {
      key
      value
    }
  }
}`
export const GET_FOLDER_ALL_DETAILS = gql`query GetFolderAllDetails($id: ID!) {
  folder(id: $id) {
    id
    name
    files {
      id
      name
      archived
      deleted
      last_modified
      tags {
        key
        value
      }

      tracks {
        index
        enabled
        language
        track_type
      }
      stills {
        url
        name
      }
      ffprobe
      warnings
      extra_info
      mediainfo
      mediainfo_json
    }
    tags {
      key
      value
    }
    parents {
      id
      name
    }
  }
}`
export const FILE_DETAILS = gql`query GetFile($id: ID!) {
  file(id: $id) {
    id
    name
    archived
    deleted
    last_modified
    tags {
      key
      value
    }

    tracks {
      index
      enabled
      language
      track_type
    }
    stills {
      url
      name
    }
    ffprobe
    warnings
    extra_info
    mediainfo
    mediainfo_json
  }
}`

export const GET_POLICIES = (org_id: string) => gql`query GetPolicies${org_id.replace(new RegExp(':', 'g'), '_')} {
  policies {
    policies {
      display_name
      statements {
        actions
        effect
        resources
        conditions {
          key
          operator
          values
        }
      }
    }
  }
}`

export const GET_ROOTS = (org_id: string) => gql`query GetRoots${org_id.replace(new RegExp(':', 'g'), '_')} {
  roots {
    id
    name
    last_modified
  }
}`

export const CREATE_EDITING_WORKSPACE = gql`mutation create_editing_workspace($pool: String!, $availabilityZone: String!, $contents: [ID!]!, $mountPoint: String!, $message: String) {
  createEditingWorkspace(input: {pool: $pool, availabilityZone: $availabilityZone, contents: $contents, mountPoint: $mountPoint, message: $message}) {
    action
    data
    message
    state
    id
    start_date
    end_date
  }
}`

export const GET_EDITING_WORKSPACES = gql`query editing_workspaces($input: EditingWorkspacesQueryInput!) {
  editingWorkspaces(input: $input) {
    id
    status
    mountPoint
    volumeSizeGiB
    availabilityZone
    awsRegion
    createdAt
    completedAt
    errorMessage
    mountedOn
    driveLetter
    mountPath
    pool
  }
}`

export const MOUNT_EDITING_WORKSPACE = gql`mutation mount_editing_workspace($input: MountEditingWorkspaceInput!) {
  mountEditingWorkspace(input: $input) {
    id
    state
    message
  }
}`

export const UNMOUNT_EDITING_WORKSPACE = gql`mutation unmount_editing_workspace($input: UnmountEditingWorkspaceInput!) {
  unmountEditingWorkspace(input: $input) {
    id
    state
    message
  }
}`

export const GET_DESKTOP_HOSTS = gql`query desktop_hosts($input: DesktopHostsQueryInput!) {
  desktopHosts(input: $input) {
    instanceId
    name
    state
    instanceType
    awsRegion
    availabilityZone
    publicIp
    pool
    setupDate
    screens
    network
  }
}`

export const START_DESKTOP_HOST = gql`mutation start_desktop_host($input: StartDesktopHostInput!) {
  startDesktopHost(input: $input) {
    id
    state
    message
  }
}`

export const SETUP_DESKTOP_HOST = gql`mutation setup_desktop_host($input: SetupDesktopHostInput!) {
  setupDesktopHost(input: $input) {
    id
    state
    message
  }
}`

export const STOP_DESKTOP_HOST = gql`mutation stop_desktop_host($input: StopDesktopHostInput!) {
  stopDesktopHost(input: $input) {
    status
  }
}`

export const GET_HOSTS_AND_WORKSPACES = gql`
  query hosts_and_workspaces($hostsInput: DesktopHostsQueryInput!, $workspacesInput: EditingWorkspacesQueryInput!) {
    desktopHosts(input: $hostsInput) {
      instanceId name state instanceType awsRegion availabilityZone publicIp pool setupDate screens network
    }
    editingWorkspaces(input: $workspacesInput) {
      id status mountPoint volumeSizeGiB availabilityZone awsRegion createdAt completedAt errorMessage mountedOn driveLetter mountPath pool
    }
  }
`

export const JOIN_CRD_SESSION = gql`mutation join_crd_session($input: JoinCrdSessionInput!) {
  joinCrdSession(input: $input) {
    id
    state
    message
    data
  }
}`

export const MKDIR = gql`mutation mkdir($folder_id: ID!) {
  mkdir(input: {folder_id: $folder_id}) {
    created
    parent {
      id
      name
    }
  }
}`

// VTK-3398: writes a small generated file (the title card WebVTT, as a data: URI) into the repository.
export const COPY_FILE = gql`
  mutation CopyFile($src: String!, $dest: String!) {
    copy_file(input: {src: $src, dest: $dest}) {
      id
      state
      message
    }
  }
`;

export const GET_FOLDER_SECURITY_LEVEL = gql`query GetFolderSecurityLevel($id: ID!) {
  folder(id: $id) {
    id
    security_level
  }
}`

/** VTK-3622: the DRM mode, licence token and keys for one viewer (re)connect. */
export const CRD_DRM_SESSION = gql`query crd_drm_session($input: CrdDrmSessionInput!) {
  crdDrmSession(input: $input) {
    mode
    token
    tokenExpiresAt
    merchant
    environment
    mediaBufferMs
    video { kid iv encryption codec }
    audio { kid iv encryption codec }
  }
}`;
